export default __webpack_public_path__ + "static/media/3233 spice rack F side.7d97488d.png";